import React, {useEffect, useState} from 'react';
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import apiUser from "../../../apiUser";
import TecRmiSvgHtml from "../TecRmiSvgHtml";
import ManualModal from "./ManualModal";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import {Alert} from "reactstrap";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import InputSearchWithButton from "../../../componentsReusable/InputSearchWithButton";
import appUserRoutes from "../../../appUserRoutes";
import {getByModuleId, MODULE_MANUALS_ERROR_CODE} from "../Modules";
import {useHistory} from "react-router-dom";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import PrintButton from "../PrintButton";
import Breadcrumb from "../../Breadcrumb";
import {TAB_MODULES} from "../../../views/UserViews/TecRmi/MainView";

const ManualsErrorCode = props => {
  const { getApiPrimaryParams, ident, setPrintData, unsetPrintData } = useTecRmi()
  const history = useHistory();
  const [loading, setLoading] = useState(false)
  const [errorCodeHtml, setErrorCodeHtml] = useState(null)
  const [modalManualId, setModalManualId] = useState(null)

  useEffect(() => () => unsetPrintData(), [])

  useDidMountEffect(() => {
    if(getErrorCode()){
      findErrorCode()
    }
  })

  useAfterUpdateEffect(() => {
    findErrorCode()
  }, [props.params])

  const getErrorCode = () => {
    return props.params[0]
  }
  const findErrorCode = () => {
    if(loading){
      return
    }
    setErrorCodeHtml(null)

    if(getErrorCode() !== ''){
      setLoading(true)

      const params = {
        ...getApiPrimaryParams(),
        errorCode: getErrorCode(),
        linkUrl: '',
      }

      setPrintData(apiUser.tecRmi.manuals.errorCodeSearchHtmlPrint, {
        ...params,
        printView: true,
      })

      apiUser.tecRmi.manuals.errorCodeSearchHtml(params)
        .then(res => setErrorCodeHtml(res.data))
        .finally(() => setLoading(false))
    }else{
      unsetPrintData()
    }
  }

  const handleClick = (e) => {
    if(e.target.closest('a')){
      e.preventDefault()
      const href = e.target.closest('a').getAttribute('href')
      switch (href.substring(0, 2)) {
        case 'Þe': {
          setModalManualId(href.match(/\d+/g).join(''))
          break;
        }
        default: {
          //todo
          break;
        }
      }
    }
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <Breadcrumb
          crumbs={[
            {
              name: <i className="fas fa-chevron-circle-left" />,
              path: appUserRoutes.tecRmi.tab(ident, TAB_MODULES),
            },
            {
              name: getByModuleId(MODULE_MANUALS_ERROR_CODE, 'name'),
              path: '',
            },
          ]}
        />

        <div className="d-flex flex-row flex-nowrap justify-content-end">
          <PrintButton />
          <InputSearchWithButton
            onInputChanged={errorCode => {
              history.push(appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_MANUALS_ERROR_CODE, 'uriName'), errorCode))
            }}
            value={getErrorCode()}
          />
        </div>
      </div>

      <div className="mt-2">
        {!getErrorCode() && <Alert className="text-center" color={'warning'}>
          <span>Wpisz kod błędu aby wyszukać</span>
        </Alert>}
        {loading && <LoadingSpinner />}
        {errorCodeHtml && <TecRmiSvgHtml html={errorCodeHtml[0]} handleClick={handleClick} />}
      </div>

      {modalManualId && <ManualModal
        onClose={() => setModalManualId(null)}
        manualId={modalManualId}
      />}
    </div>
  );
};

ManualsErrorCode.defaultProps = {
  params: [],
};

export default ManualsErrorCode;